import { render } from "./SBPPanel.vue?vue&type=template&id=17897842&scoped=true&ts=true"
import script from "./SBPPanel.vue?vue&type=script&lang=ts"
export * from "./SBPPanel.vue?vue&type=script&lang=ts"

import "./SBPPanel.vue?vue&type=style&index=0&id=17897842&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17897842"]])

export default __exports__